import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import AOS from "aos";
import React, { useEffect, useState } from "react";
import "aos/dist/aos.css";
import BannerVideo from "./Component/bannerVideo";
import VideoGallery from "./Component/videogallery";
import Navbar from "./Component/navBar";
import Footer from "./Component/footer";
import Home from "./Component/Home";
import PricingSection from "./Component/work";
import About from "./Component/about";
import Services from "./Component/service";
import MyWorks from "./Component/work";
import GalleryR from "./Component/reportage";
import GalleryP from "./Component/portrait";
import GalleryP2 from "./Component/packshot";
import GalleryI from "./Component/insert";
import GalleryE from "./Component/evenement";
import Contact from "./Component/contact";
import Team from "./Component/team";
import Preloader from "./Component/preloader"; 
import ScrollToTop from "./Component/Progresstop";
import GalleryM from "./Component/mariages";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: false,
    });

    const timer = setTimeout(() => setLoading(false), 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading && <Preloader />}
      {!loading && (
        <>
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <About />
                  <BannerVideo />
                  <Services />
                  <MyWorks />
                  <Contact />
                </>
              }
            />
            <Route
              path="/aPropos"
              element={
                <>
                  <About />
                  <Team />
                </>
              }
            />
            <Route path="/service" element={<PricingSection />} />
            <Route path="/rea" element={<VideoGallery />} />
            <Route path="/photo/reportage" element={<GalleryR />} />
            <Route path="/photo/portrait" element={<GalleryP />} />
            <Route path="/photo/evenementiel" element={<GalleryE />} />
            <Route path="/photo/industriel" element={<GalleryI />} />
            <Route path="/photo/packshot" element={<GalleryP2 />} />
            <Route path="/photo/mariage" element={<GalleryM />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <ScrollToTop />
        </>
      )}
    </div>
  );
}


export default App;
